import Component from './component';

export interface Props {
    background: any;
    // background: FileUpload;
}

Component.defaultProps = {};

export default Component;